export class UnitOfMeasureModel {
    Id: number;
    Name: string;
    UnitCount: number;
    UnitType: number;
    Abbreviation: string;

    constructor() {
        this.Name = "";
        this.Abbreviation = "";
    }
}